module.exports = __webpack_public_path__ + "static/img/car_naiguan@3x.dcd54576.png";